import React from "react";
import { Text } from "@theme-ui/components";

const Paragraph = ({ as = "p", content }) => (
  <Text
    as={as}
    sx={{
      breakBefore: "avoid",
      overflowWrap: "break-word",
      pageBreakInside: "avoid",
      maxWidth: 900,
      mb: [4],
      "& a": {
        overflowWrap: "break-word",
      },
    }}
    variant="paragraph"
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

export default Paragraph;
